import React from 'react';
import './App.css';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { MDBCard, MDBCardBody, MDBView, MDBBtn } from 'mdbreact';
import { MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import Lightbox from "react-image-lightbox";
import { MDBNavbar, MDBNavbarBrand } from 'mdbreact';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
class App extends React.Component {

  constructor(props) {
    super(props);
    this.openImageInNewWindow = this.openImageInNewWindow.bind(this);
    this.deleteSelectedImage = this.deleteSelectedImage.bind(this);
    this.getTokenHash = this.getTokenHash.bind(this);
    this.getCookie = this.getCookie.bind(this);

    this.state = {
      photoIndex: 0,
      modal: false,
      isOpen: false,
      error: null,
      isLoaded: false,
      images: [],
      path: '',
    };
  }


  getTokenHash(cname) {
    var name = cname + "=";
    var fy_cookie = '';
    var tokenId = '';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) ===' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        fy_cookie = c.substring(name.length, c.length);
      }
    }
    if (fy_cookie.length > 0) {
      fy_cookie = fy_cookie.split('.')[1];
      fy_cookie = fy_cookie.replace('-', '+').replace('_', '/');
      var fyObj = JSON.parse(atob(fy_cookie));
      tokenId = fyObj.at_hash;
      return { 'tokenHash': tokenId }

    } else {
      return { 'tokenHash': '' }
    }
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  componentDidMount() {
    var tokenId;
    //var LOGINURLPATH = "http://betalogin.fyers.in//?cb=https://savedcharts.fyers.in";
    //var LOGINURLPATH = "https://dev.fyers.in/newauth-beta/index.html?cb=http://apidashboard-dev.fyers.in";
    var LOGINURLPATH = "https://login.fyers.in/?cb=https://savedcharts.fyers.in";
    var funcRet = this.getTokenHash("_FYERS");
    var fcookie = this.getCookie("_FYERS");

    if (document.cookie.indexOf("_FYERS") === -1) {
      window.location = LOGINURLPATH;
      //alert("Its me")
    }
    else {
      tokenId = funcRet.tokenHash;
      //alert(tokenId);
    }
     
    // fetch("https://data.fyers.in/fy/v1/gallery?token_id="+tokenId)
    // fetch("https://data.fyers.in/fydev/v1/gallery?token_id=" + tokenId)
      fetch("https://data.fyers.in/fydev/v1/gallery?token_id=" + tokenId, {
        headers: {
          Authorization: fcookie
        }
      })
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true
          });

          if (result.s === "error") {
            window.location = LOGINURLPATH;
          }
          else if (result.s === "ok") {

            function sortByDate(data) {
              data.d.sort(function (a, b) {
                return new Date(b.lastModified * 1000) - new Date(a.lastModified * 1000);
              });
              return data;
            }

            var returnedDateValue = sortByDate(result);

            var urlImages = [];
            for (var i in returnedDateValue.d) {
              var theDate = new Date(returnedDateValue.d[i].lastModified * 1000);
              var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              var year = theDate.getFullYear();
              var month = months[theDate.getMonth()];
              var date = theDate.getDate();
              var hours = theDate.getHours();
              var minutes = theDate.getMinutes();
              var ampm = hours >= 12 ? 'PM' : 'AM';
              hours = hours % 12;
              hours = hours ? hours : 12;
              minutes = minutes < 10 ? '0' + minutes : minutes;
              var chartDate = date + ' ' + month + ' ' + year + ' ' + hours + ':' + minutes + ' ' + ampm;
              urlImages.push({ 'path': returnedDateValue.d[i].url, 'mdate': chartDate });
            }

            this.setState({
              images: urlImages
            });
          }

        },
        (error) => {
          this.setState({
            isLoaded: true,
           // loginpath:"http://betalogin.fyers.in//?cb=https://savedcharts.fyers.in",
            loginpath:"https://login.fyers.in/?cb=https://savedcharts.fyers.in",
              // loginpath: "https://dev.fyers.in/newauth-beta/index.html?cb=http://apidashboard-dev.fyers.in",
            error
          });
        }
      )
  }

  toastId = null;

  notify = () => this.toastId = toast("Link Copied to clipboard", { autoClose: 2000 });

  notifyDelete = () => {

    toast("Chart deleted successfully", {
      position: toast.POSITION.TOP_,
      autoClose: 2000,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  openImageInNewWindow() {
    const { photoIndex, images } = this.state;
    var imageSource = images[photoIndex].path;
    return imageSource;
  }


  deleteSelectedImage(e) {
    var tokenId;
    //var LOGINURLPATH = "http://betalogin.fyers.in//?cb=https://savedcharts.fyers.in";
    var LOGINURLPATH = "https://login.fyers.in/?cb=https://savedcharts.fyers.in";

    // var LOGINURLPATH = "https://dev.fyers.in/newauth-beta/index.html?cb=http://apidashboard-dev.fyers.in";
    var funcRet = this.getTokenHash("_FYERS");

    if (funcRet.length <= 0) {
      window.location = LOGINURLPATH;
    }
    else {
      tokenId = funcRet.tokenHash;
    }
    const { photoIndex } = this.state;
    var array = [...this.state.images];
    var arrayLenght = array.length;
    var imgIndex = this.state.photoIndex;
    var imageDelete = array[photoIndex].path;
    var imageSplit = imageDelete.split('/');
    var imageDeleteName = imageSplit[imageSplit.length - 1];

    var fcookiedel = this.getCookie("_FYERS");
    console.log("cookie for delete" +fcookiedel);
    var bodyParams = {
      token_id: tokenId,
      images: imageDeleteName
    }

   
    fetch('https://data.fyers.in/fydev/v1/gallery', {
      method: 'DELETE',
      headers: {
         Authorization: fcookiedel,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyParams)
    })
      .then(res => res.json())
      .then(res => {
        var lastImgIndex = arrayLenght - 1;
        if (imgIndex === lastImgIndex) {
          this.setState({ photoIndex: 0 });
          array.splice(photoIndex, 1);
          this.setState({ images: array });
        }
        else if (photoIndex !== -1) {
          array.splice(photoIndex, 1);
          this.setState({ images: array });
        }
        else {
          console.log("Something went wrong");
        }
        this.setState({ modal: false });
        this.notifyDelete();
      })

    this.setState({ modal: false });
  }


  renderImages = () => {
    if (this.state.images.length > 0) {
      let photoIndex = -1;
      const { images } = this.state;

      return images.map(imageSrc => {
        photoIndex++;
        const privateKey = photoIndex;

        return (
          <MDBCol md="3" key={photoIndex} className="hoverable" style={{ marginBottom: "60px", height: "100%", width: "100%" }}>
            <p style={{ marginBottom: "5px", fontSize: "15px", fontWeight: "400" }}> {imageSrc.mdate}</p>
            <MDBView hover zoom>
              <div className="container" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                <img src={imageSrc.path} alt="Gallery" className="img-fluid" onClick={() =>
                  this.setState({ photoIndex: privateKey, isOpen: true })
                }
                />
              </div>
            </MDBView>
          </MDBCol>
        );
      })
    }
    else {
      return (
        <div className="container">
          <div class="errorMsg" >
            <p style={{ textAlign: "center" }}>Looks like there are no saved charts in your account.</p>
          </div>
        </div>
      );
    }
  }

  render() {

    const { photoIndex, isOpen, error, isLoaded, images } = this.state;

    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div class="container">
        <div style={{ marginTop: "30%", textAlign: "center", verticalAlign: "middle" }}>
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>;
    }
    else {
      return (
        <div>
          <Router>
            <header>
              <MDBNavbar style={{ backgroundColor: "#f8f9fa", height: "65px" }} dark expand="md" scrolling fixed="top">
                <MDBNavbarBrand href="/" style={{ marginLeft: "4%" }}>
                  <strong><img src="../assets/savedChart.png" alt="save-chart" height="60" width="150"/></strong>
                </MDBNavbarBrand>
              </MDBNavbar>
            </header>
          </Router>
          <MDBContainer fluid className="mt-5">
            <MDBCol style={{ marginTop: "9%" }}>
              <MDBCard style={{ width: "94%", marginLeft: "3%", marginRight: "3%" }}>
                <MDBCardBody>
                  <div className="mdb-lightbox">
                    <MDBRow>
                      {this.renderImages()}
                    </MDBRow>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBContainer>
              <p></p>
            </MDBContainer>
            {isOpen && images.length > 0 && (
              <Lightbox
                mainSrc={images[photoIndex].path}
                nextSrc={images[(photoIndex + 1) % images.length].path}
                prevSrc={images[(photoIndex + images.length - 1) % images.length].path}
               // imageTitle={photoIndex + 1 + "/" + images.length}
                imageTitle={images[photoIndex]["mdate"]}
                clickOutsideToClose={false}
                toolbarButtons={[
                  <div>
                    <CopyToClipboard text={this.openImageInNewWindow()}>
                      <button title="Copy Link" onClick={this.notify} style={{ background: "transparent", border: "none", color: "rgba(242, 243, 244, 0.79)", paddingTop: "8px" }} key="fullscreen"><i className="material-icons">link</i></button>
                    </CopyToClipboard>
                    <ToastContainer />
                  </div>,
                  <button title="Open in new tab" style={{ background: "transparent", border: "none", color: "rgba(242, 243, 244, 0.79)", marginRight: "15px", marginLeft: "15px", paddingTop: "8px" }} key="fullscreen" onClick={() => window.open(this.openImageInNewWindow(), "_blank")}><i className="material-icons">open_in_new</i></button>,
                  <div>
                    <MDBContainer style={{ paddingLeft: "0px" }}>
                      <button title="delete" style={{ background: "transparent", border: "none", color: "rgba(242, 243, 244, 0.79)", paddingTop: "8px" }} key="fullscreen" onClick={this.toggle} ><i className="material-icons">delete</i></button>
                      <MDBModal isOpen={this.state.modal} toggle={this.toggle} centered backdrop={false}>
                        <MDBModalHeader toggle={this.toggle} style={{ color: "#000" }}>Delete Image</MDBModalHeader>
                        <MDBModalBody style={{ color: "#000" }}>
                          Are you sure you want to delete this image?
                        </MDBModalBody>
                        <MDBModalFooter>
                          <MDBBtn className="cancelBtnStyle" onClick={this.toggle}>No</MDBBtn>
                          <MDBBtn color="primary" onClick={this.deleteSelectedImage}>Yes</MDBBtn>
                        </MDBModalFooter>
                      </MDBModal>
                    </MDBContainer>
                  </div>,
                ]}
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + images.length - 1) % images.length
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % images.length
                  })
                }
              />
            )}
          </MDBContainer>
        </div>
      );
    }
  }
}


export default App;
